var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductNeedToApprove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1046_233974)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 16,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFCF00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.895 28.4674C57.9458 27.8442 63.0541 27.8442 68.105 28.4674C68.9083 28.5709 69.6461 28.9646 70.1793 29.5743C70.7125 30.184 71.0044 30.9676 70.9999 31.7776V53.875C71 54.0653 70.9517 54.2525 70.8597 54.419C70.7677 54.5856 70.6349 54.7261 70.4738 54.8274C70.3127 54.9287 70.1286 54.9874 69.9386 54.9982C69.7486 55.009 69.559 54.9714 69.3875 54.8889L65.1875 52.8731L60.9875 54.8889C60.8354 54.962 60.6688 55 60.5 55C60.3312 55 60.1646 54.962 60.0125 54.8889L55.8125 52.8731L51.6125 54.8889C51.441 54.9714 51.2514 55.009 51.0614 54.9982C50.8714 54.9874 50.6872 54.9287 50.5261 54.8274C50.365 54.7261 50.2323 54.5856 50.1402 54.419C50.0482 54.2525 50 54.0653 50 53.875V31.7776C50 30.1232 51.209 28.6759 52.895 28.4674ZM60.128 35.9622C60.2413 35.8643 60.3339 35.7448 60.4004 35.6107C60.4669 35.4765 60.506 35.3305 60.5153 35.1811C60.5246 35.0317 60.504 34.8819 60.4547 34.7405C60.4054 34.5992 60.3284 34.4691 60.2282 34.3579C60.1279 34.2467 60.0065 34.1566 59.871 34.0929C59.7355 34.0292 59.5887 33.9932 59.4391 33.987C59.2895 33.9808 59.1401 34.0046 58.9998 34.0568C58.8595 34.1091 58.7311 34.1888 58.622 34.2913L54.872 37.666C54.755 37.7715 54.6615 37.9004 54.5975 38.0443C54.5334 38.1882 54.5004 38.3439 54.5004 38.5014C54.5004 38.6589 54.5334 38.8147 54.5975 38.9586C54.6615 39.1025 54.755 39.2314 54.872 39.3369L58.622 42.7115C58.8447 42.9039 59.1339 43.0014 59.4276 42.983C59.7213 42.9647 59.9961 42.832 60.1931 42.6134C60.3902 42.3948 60.4937 42.1078 60.4815 41.8138C60.4693 41.5198 60.3424 41.2422 60.128 41.0407L58.556 39.6263H61.4375C62.1834 39.6263 62.8988 39.9226 63.4262 40.45C63.9537 40.9774 64.25 41.6927 64.25 42.4386C64.25 43.1844 63.9537 43.8997 63.4262 44.4271C62.8988 44.9545 62.1834 45.2508 61.4375 45.2508C61.1391 45.2508 60.853 45.3693 60.642 45.5803C60.431 45.7912 60.3125 46.0774 60.3125 46.3757C60.3125 46.674 60.431 46.9602 60.642 47.1711C60.853 47.3821 61.1391 47.5006 61.4375 47.5006C62.7801 47.5006 64.0678 46.9673 65.0172 46.018C65.9666 45.0686 66.5 43.7811 66.5 42.4386C66.5 41.096 65.9666 39.8085 65.0172 38.8592C64.0678 37.9099 62.7801 37.3765 61.4375 37.3765H58.5575L60.128 35.9622Z",
    fill: "#696969"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1046_233974",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1046_233974"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1046_233974"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1046_233974",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductNeedToApprove);
export default __webpack_public_path__ + "static/media/product_need_to_approve.1863e4c2153793a47520f02f994c059f.svg";
export { ForwardRef as ReactComponent };